import { useEffect } from "react";

export const HUBSPOT_PORTAL_ID = import.meta.env.VITE_HUBSPOT_PORTAL_ID as string | undefined;

declare global {
  interface Window {
    hsConversationsSettings?: Record<string, unknown>;
    hsConversationsOnReady?: Array<() => void>;
    HubSpotConversations?: {
      widget: {
        load: (options?: { widgetOpen?: boolean }) => void;
        open: () => void;
        remove: () => void;
        status: () => { loaded: boolean };
      };
      on: (event: string, handler: () => void) => void;
      clear: (options?: { resetWidget?: boolean }) => void;
    };
  }
}

function openChatNow() {
  const conversations = window.HubSpotConversations;
  if (!conversations) {
    return;
  }
  if (conversations.widget.status().loaded) {
    conversations.widget.open();
    return;
  }
  conversations.on("widgetLoaded", () => {
    window.HubSpotConversations?.widget.open();
  });
  conversations.widget.load({ widgetOpen: true });
}

export function openSupportChat() {
  if (window.HubSpotConversations) {
    openChatNow();
    return;
  }

  window.hsConversationsOnReady = [...(window.hsConversationsOnReady ?? []), openChatNow];
}

export function HubSpotChatLoader() {
  useEffect(() => {
    if (!HUBSPOT_PORTAL_ID || document.getElementById("hs-script-loader")) {
      return;
    }

    window.hsConversationsSettings = { ...window.hsConversationsSettings, loadImmediately: false };
    window.hsConversationsOnReady = [
      ...(window.hsConversationsOnReady ?? []),
      () => {
        window.HubSpotConversations?.on("widgetClosed", () => {
          window.HubSpotConversations?.widget.remove();
        });
      },
    ];

    const script = document.createElement("script");
    script.id = "hs-script-loader";
    script.async = true;
    script.defer = true;
    script.src = `https://js-eu1.hs-scripts.com/${HUBSPOT_PORTAL_ID}.js`;
    document.body.appendChild(script);
  }, []);

  return null;
}
